import {
  HubspotIcon,
  JavascriptIcon,
  SalesforceIcon,
  StripeIcon,
  ServerSideIcon,
  ReactJsIcon,
  SendInBlueIcon,
  MailchimpIcon,
  IntercomIcon,
} from "../components/icons/themes/logos";
import { Source } from "./types";

import { AndroidOsIcon, AppleLogoIcon } from "../components/icons/themes/color";

export const sources: Source[] = [
  {
    key: "Autotrack",
    name: "Autotrack",
    logo: "autotrack_logo.png",
    logoSquare: JavascriptIcon,
    modal: "Autotrack",
  },
  {
    key: "Precision Tracking",
    name: "Precision Tracking",
    logo: "precision_track_logo.png",
    logoSquare: JavascriptIcon,
    modal: "Precision Tracking",
  },
  {
    key: "Server Side",
    name: "Server-side",
    logo: "server_side_events_logo.png",
    logoSquare: ServerSideIcon,
    modal: "Server Side",
  },
  {
    key: "React Native",
    name: "React Native",
    logo: "server_side_events_logo.png",
    logoSquare: ReactJsIcon,
    modal: "React Native",
  },
  {
    key: "Android",
    name: "Android",
    logo: "server_side_events_logo.png",
    logoSquare: AndroidOsIcon,
    modal: "Android",
  },
  {
    key: "iOS",
    name: "iOS",
    logo: "server_sides_events_logo.png",
    logoSquare: AppleLogoIcon,
    modal: "iOS",
  },
  {
    key: "Hubspot",
    name: "Hubspot",
    logo: "hubspot_logo.png",
    logoSquare: HubspotIcon,
    modal: "Contact Us",
    body:
      "Automatically import data about email activity, deals, and contacts without any ETL.",
  },
  {
    key: "Stripe",
    name: "Stripe",
    logo: "stripe_logo.png",
    logoSquare: StripeIcon,
    modal: "Contact Us",
    body:
      "Automatically import data about charges, refunds, and chargebacks without any ETL.",
  },
  {
    key: "SFDC",
    name: "Salesforce",
    logo: "salesforce_logo.png",
    logoSquare: SalesforceIcon,
    modal: "Contact Us",
    body:
      "Automatically import contacts, accounts, and any other user-centric data.",
  },
  {
    key: "Sendinblue",
    name: "Sendinblue",
    logo: "sendinblue_logo.png",
    logoSquare: SendInBlueIcon,
    modal: "Sendinblue",
  },
  {
    key: "Mailchimp",
    name: "Mailchimp",
    logo: "mailchimp_icon.png",
    logoSquare: MailchimpIcon,
    modal: "Mailchimp",
  },
  {
    key: "Intercom",
    name: "Intercom",
    logo: "intercom_icon.png",
    logoSquare: IntercomIcon,
    modal: "Intercom",
  },
];
